<template>
  <b-card
    style="min-width: 100%; overflow-x: scroll"
    header="Utilidad ó Pérdida (Expresado en Miles C$)"
  >
      <section v-if="cargando">
          <loader-ag />
          <b-row>
            <p class="text-primary mx-auto">Por favor espere...</p>
          </b-row>
        </section>

    <highcharts
      v-else
      style="height: 500px; min-width: 520px; max-width: 900px; margin: 0 auto"
      :options="chartOptions"
    ></highcharts>
  </b-card>
</template>
<script>
import { Chart } from "highcharts-vue";
import Highcharts from "highcharts";
import exportingInit from "highcharts/modules/exporting";
import LoaderAg from "@/components/LoaderAg";

exportingInit(Highcharts);
Highcharts.setOptions({
  lang: {
    decimalPoint: ".",
    thousandsSep: ",",
  },
});
export default {
  name: "GraficoUtilidad",
  props:{
  empresa_id:{
    type:Number,
    required: true
  }
},
  components: {
    LoaderAg,
    highcharts: Chart,
  },
  mounted(){
    this.loadData()
  },
  data() {
    return {
      cargando:true,
      chartOptions: {
        /* navigation: {
        buttonOptions: { align: 'left' }
        },*/
        colors: ["#1F363D", "#40798c", "#70A9A1", "#9EC1A3"],
        chart: {
            /*  resetZoomButton: {
            position: {
            verticalAlign: 'bottom',
            x: -600,
            y: -50
            }
            },*/
          type: "column",
          zoomType: "xy",
        },
        title: {
          text: "",
        },
        xAxis: {
          categories: [
            "Ene",
            "Feb",
            "Mar",
            "Abr",
            "May",
            "Jun",
            "Jul",
            "Ago",
            "Sep",
            "Oct",
            "Nov",
            "Dic",
          ],
        },
        yAxis: {
          title: {
            text: "Utilidad",
          },
        },
        credits: {
          enabled: false,
        },
        legend: {
          verticalAlign: "top",
        },
        series: []
      },
    };
  },
  methods: {
      async loadData() {
      try {
        this.cargando=true;
        // eslint-disable-next-line no-undef
        const {data, status} = await axios.post('/api/reportes/utilidad-perdida', {empresa_id: parseInt(this.empresa_id)});

        if (status !== 200)
           this.chartOptions.series = [];
      let series = data;
        series.forEach(element => {
          let datafinal = element.data.map(d=> parseFloat(d));
          element.data = datafinal;
        });

        this.chartOptions.series = series;
        this.cargando=false;
      } catch (e) {
        console.error(e);
      }
    }
  },
  }
</script>
